export default __webpack_public_path__ + "static/media/7.d94dca69.jpg";